// extracted by mini-css-extract-plugin
export default {"fsProductGrid":"product-grid-module--fs-product-grid--39183"};